<template>
    <div class="panel qb-margin-top">
        <div class="title qb-container">
          <h2>Ultimos Pedidos</h2>
        </div>
        <div class="panel-content">
            <vue-element-loading :active="showProdutos"/>
        <div class="grid-pedidos qb-margin">
            <div  @click="show(pedido.id.toString())" v-for="pedido in pedidos" :key="pedido.id" class="pedido qb-shadow-1 qb-padding">
                <p class="qb-txt-md">#{{pedido.id}}</p>
                <p class="qb-txt-md">{{pedido.dateOrder}}</p>
                <p class="qb-txt-color-price qb-txt-bold qb-txt-md" >{{priceFormater(pedido.total)}}</p>
                <ChevronRight class="md-28" />
            </div>
        </div>
        <modal v-for="pedido in pedidos" :key="pedido.id" :name="pedido.id.toString()" :adaptive="true" height="auto" :pivotX="0.6" :scrollable="true" @before-open="beforeOpen" @before-close="beforeClose">
            <div class="qb-padding">
                <div style="display: flex;align-items: center;justify-content: space-between;border-bottom: 1px solid lightgrey;">
                    <header><h4>Pedido # {{ pedido.id }} </h4></header>
                    <p class="qb-txt-color-price qb-txt-bold qb-txt-lg">{{ priceFormater(pedido.total) }}</p>
                </div>
                <div>
                    <div>
                        <h4>Produtos</h4>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th class="qb-txt-color-price qb-txt-bold qb-txt-md">Código</th>
                                <th class="qb-txt-color-price qb-txt-bold qb-txt-md">Descrição</th>
                                <th class="qb-txt-color-price qb-txt-bold qb-txt-md">Valor Un.</th>
                                <th class="qb-txt-color-price qb-txt-bold qb-txt-md">Qtd</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="produto in produtos" :key="produto.id">
                                <td><p class="qb-txt-sm">{{ produto.productId }}</p></td>
                                <td><p class="qb-txt-sm">{{ produto.description }}</p></td>
                                <td><p class="qb-txt-sm">{{ priceFormater(produto.discountPrice) }} *</p></td>
                                <td><p class="qb-txt-sm">{{ produto.quantity }}</p></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="qb-txt-sm qb-txt-bold">* o valor do produto pode sofrer alterações</p>
                <button class="btn btn-primary btn-sm qb-margin-top qb-margin-bottom" style="float: right;" @click="show('confirma')">Copiar Pedido</button>
                <button v-if="pedido.situation == 'ABERTO'" class="btn btn-danger btn-sm qb-margin-top qb-margin-bottom"  @click="Clean(pedido.id)" style="float: left;">
                    Excluir Pedido 
                </button>
            </div>
            <modal name="confirma" :adaptive="true" height="auto" :pivotX="0.6" width="400px" :clickToClose="false">
                <div>
                    <div class="titulo qb-shadow-1">
                        <h4 class="qb-padding btn-danger qb-txt-white" style="margin-top: 0px;">Confirmar cópia do pedido?</h4>
                    </div>
                    <div class="conteudo qb-container">
                        <p class="qb-txt-color-price qb-txt-bold qb-txt-xl">Atenção</p>
                        <p>O valor do pedido pode ficar diferente do valor do pedido original</p>
                        <p>Ao confirmar a cópia, todos os itens que você possui no carrinho serão <span class="qb-txt-bold qb-txt-danger">deletados</span></p>
                    </div>
                    <div class="botoes-acao qb-padding" style="display: flex;justify-content: flex-end;">
                        <button class="btn btn-danger" style="margin-right: 16px;" @click="$modal.hide('confirma')">Cancelar</button>
                        <button class="btn btn-alert" @click="copiarPedido(pedido.id)" >Confirmar</button>
                    </div>
                </div>
            </modal>
        </modal>

            <modal name="produtosNaoCopiados" :adaptive="true" height="auto" :pivotX="0.6" width="400px" :clickToClose="false">
                <div>
                    <div class="titulo qb-shadow-1">
                        <h4 class="qb-padding btn-primary qb-txt-white" style="margin-top: 0px;">Pedido copiado com sucesso</h4>
                    </div>
                    <div class="conteudo qb-container">
                        <p class="qb-txt-color-price qb-txt-bold qb-txt-xl">Atenção</p>
                        <p>Alguns produtos não foram copiados por que não possuem estoque disponível</p>
                        <p v-for="produto in produtosNaoCopiados" :key="produto.id">{{produto.productId}} - {{produto.description}}</p>
                    </div>
                    <div class="botoes-acao qb-padding" style="display: flex;justify-content: flex-end;">
                        <button class="btn btn-primary btn-full" @click="$modal.hide('produtosNaoCopiados')">OK</button>
                    </div>
                </div>
            </modal>
        </div>
      </div>
</template>

<script>
import axios from "axios";
import { baseApiUrl, userKey } from "@/global";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import Trash from "vue-material-design-icons/TrashCan.vue";
import VueElementLoading from 'vue-element-loading';
export default {
    components:{
        ChevronRight,
        VueElementLoading,
        Trash
    },
    data (){
        return{
            pedidos: [],
            produtos: [],
            showProdutos: true,
            produtosNaoCopiados: []
        }
    },
    methods:{
        carregaUltimosPedidos(){
            const usr = JSON.parse(localStorage.getItem(userKey));
            // const vendedor = JSON.parse(localStorage.getItem('vendedor'));
            usr.CustomerId = usr.idCliente;
            usr.Manager = usr.gestor;                       
            
            let clienteUsuarioVinculado = localStorage.getItem('cliente_usuario_vinculado');
            var idClientUser = 0;
            if (clienteUsuarioVinculado) {
                // Convertendo a string JSON de volta para um objeto
                clienteUsuarioVinculado = JSON.parse(clienteUsuarioVinculado);
                
                // Exibindo apenas o ID no console
                idClientUser = clienteUsuarioVinculado.id;
            }

            var vendedorID = 0;
            const jsonVendedor = JSON.parse(localStorage.getItem('vendedor'));
            if (jsonVendedor) {
                vendedorID = jsonVendedor.codeVendedor;
            }
            
            axios.post(`${baseApiUrl}/orders/last/${idClientUser}/${usr.CustomerId}/${vendedorID}`, usr)
            .then(res => {
                this.showProdutos=false;
                if(res.data.valid){
                    this.pedidos = res.data.obj;
                } else {
                    this.$awn.warning('Não há um histórico de pedidos.', {labels: {warning: 'Histórico Vazio'}});
                }
            }).catch(error =>{
                this.$awn.warning('Não há um histórico de pedidos.', {labels: {warning: 'Histórico Vazio'}});
            });
        },
        async Clean(idPedido){
           const confirmacao = await confirm('Excluir este pedido?');
           if(confirmacao){
            axios.get(`${baseApiUrl}/orders/DeleteOrder/${idPedido}`)
            .then(res => {
                if(res.status == 200){
                    this.$awn.warning('Pedido Excluído com sucesso', {labels: {warning: 'Excluído' }});
                    this.pedidos = [];
                    this.carregaUltimosPedidos();
                }              
            }).catch(error =>{
               console.log(error);
               this.$awn.warning(error, {labels: {warning: 'Erro ao efetuar a exclusão do pedido' }});
            });
           }
        }, 
        carregaItensPedido(idPedido){
            axios.get(`${baseApiUrl}/orders/items/${idPedido}`)
            .then(res => {
                this.produtos = res.data;
            }).catch(error =>{
                //TODO
            });
        },
         priceFormater(price){
            return price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        show (id) {
            this.$modal.show(id);
        },
        hide (id) {
            this.$modal.hide(id);
        },
        beforeOpen (event) {
            this.carregaItensPedido(event.name);
        },
        beforeClose () {
           this.produtos = [];
        },
        copiarPedido(idPedido){
            this.hide('confirma');
            this.hide(idPedido.toString());
            // const json = localStorage.getItem(userKey);
            // const userData = JSON.parse(json)
            let copy = {
                idOrderForCopy: idPedido,
                // idOrderForPaste: userData.orderId,
            };
            this.$awn.asyncBlock(axios.post(`${baseApiUrl}/orders/copy`, copy),
            resp=> {
                if(resp.data.valid){
                    if(resp.data.obj.length > 0){
                        this.produtosNaoCopiados = resp.data.obj;
                        this.show('produtosNaoCopiados');
                        return
                    }
                    this.$awn.success(resp.data.message, {labels: {success: resp.data.title }})
                }
                else{
                    this.$awn.warning(resp.data.message, {labels: {warning: resp.data.title }})
                }
            },
            err => this.$awn.alert(`API responded with code: ${err.response.status}`))
        }
    },
    created(){
        this.carregaUltimosPedidos();
    }
}
</script>

<style scoped>
.panel{
  background-color: #fff;
  height: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 320px;
}

.panel-content{
  width: 100%;
  min-width: 308px;
  margin: 0 auto;
  min-height: 20vh;
}

.grid-pedidos{
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    grid-gap: 16px
}
.panel-content {
    display: initial !important;
}
.pedido{
    display: flex;
    /*flex-direction: column;*/
    align-items: center;
    /* border: 1px solid; */
    justify-content: space-between;
    cursor: pointer;
    border-radius: 2px;    
}

table {
    border: 1px solid #ccc;
    width: 100%;
    margin:0;
    padding:0;
    border-collapse: collapse;
    border-spacing: 0;
  }

  table tr {
    border: 1px solid #ddd;
    padding: 5px;
    background: #fff;

  }

  table th, table td {
    padding: 10px 5px 10px 5px;
    text-align: center;

  }

  table th {
    text-transform: uppercase;
    letter-spacing: 1px;
  }

@media screen and (max-width: 520px){
    .grid-pedidos{
         grid-template-columns: repeat(1, 1fr);
    }
}

@media screen and (min-width: 521px) and (max-width: 769px){
    .grid-pedidos{
         grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (min-width: 770px) and (max-width: 900px){
    .grid-pedidos{
         grid-template-columns: repeat(3, 1fr);
    }
}

@media screen and (min-width: 901px) and (max-width: 1065px){
    .grid-pedidos{
         grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (min-width: 1066px) and (max-width: 1320px){
    .grid-pedidos{
         grid-template-columns: repeat(3, 1fr);
    }
}

@media screen and (min-width: 1321px) and (max-width: 1570px){
    .grid-pedidos{
         grid-template-columns: repeat(4, 1fr);
    }
}

@media screen and (min-width: 1571px) and (max-width: 1800px){
    .grid-pedidos{
         grid-template-columns: repeat(5, 1fr);
    }
}
</style>
